/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type signupFlow_viewer$ref = any;
export type signupFlow_QueryVariables = {||};
export type signupFlow_QueryResponse = {|
  +viewer: ?{|
    +component: ?string,
    +$fragmentRefs: signupFlow_viewer$ref,
  |}
|};
export type signupFlow_Query = {|
  variables: signupFlow_QueryVariables,
  response: signupFlow_QueryResponse,
|};
*/


/*
query signupFlow_Query {
  viewer {
    component(name: "signup_flow")
    ...signupFlow_viewer
    id
  }
}

fragment signupFlow_viewer on Viewer {
  id
  csrfToken
  actualPersonId
  email
  scimProvisioned
  company {
    id
    tier
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "signup_flow"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"signup_flow\")"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "signupFlow_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "signupFlow_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "signupFlow_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "csrfToken",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actualPersonId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scimProvisioned",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tier",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "signupFlow_Query",
    "operationKind": "query",
    "text": "query signupFlow_Query {\n  viewer {\n    component(name: \"signup_flow\")\n    ...signupFlow_viewer\n    id\n  }\n}\n\nfragment signupFlow_viewer on Viewer {\n  id\n  csrfToken\n  actualPersonId\n  email\n  scimProvisioned\n  company {\n    id\n    tier\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '695f8a709fb2d0eff3951b2598b1b8b6';

module.exports = node;
